import { HostErrorSignal } from './HostErrorSignal';

interface WidgetFallbackProps {
    message?: string;
    /** Passed to the host's error message when the widget was asked for a specific event. */
    eventTicker?: string;
}

/**
 * Neutral, branded fallback shown when a widget fails to load or has no data
 * to display. Kept as a plain presentational component (no hooks, no
 * 'use client') so it can render in both server components (data-miss states)
 * and client error boundaries (error.tsx). The host is told through a client child.
 */
export function WidgetFallback({
    message = 'This widget is temporarily unavailable.',
    eventTicker,
}: WidgetFallbackProps) {
    return (
        <div className="flex h-full w-full items-center justify-center p-4">
            <a
                href="https://kalshi.com"
                target="_blank"
                rel="noreferrer noopener"
                className="typ-body-x20 text-center text-text-x20 transition-colors hover:text-text-x10"
            >
                {message}
            </a>
            <HostErrorSignal eventTicker={eventTicker} />
        </div>
    );
}

export default WidgetFallback;
